import { EndpointReponseProps } from "../types";
// const baseURL = "http://localhost:8080/api";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
// const baseURL = "http://localhost:8080/api";
export const Endpoints = {
  GetAdminLogin: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/login`,
      method: "POST",
    };
  },
  GetRequestOTP: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/login/otp/send`,
      method: "POST",
    };
  },
  GetVerifyOTP: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/login/otp/validate/${token}`,
      method: "POST",
    };
  },
  GetAdminProfile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/profile`,
      method: "GET",
    };
  },

  GetAdminScopes: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/scopes`,
      method: "GET",
    };
  },

  GetTeam: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/profiles?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetOnboardTeamMember: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/onboard`,
      method: "POST",
    };
  },
  GetValidateOnboardingToken: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/onboard/${token}`,
      method: "GET",
    };
  },
  GetCompleteOnboarding: (token: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/onboard/${token}`,
      method: "POST",
    };
  },
  GetUpdateTeamMemberProfile: (adminID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/profile/${adminID}`,
      method: "PUT",
    };
  },
  GetDeleteTeamMemberProfile: (adminID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/auth/${adminID}`,
      method: "DELETE",
    };
  },
  GetPlans: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plans/filter?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetCreatePlan: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plan/create`,
      method: "POST",
    };
  },
  GetUpdatePlan: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plan/update/${planID}`,
      method: "PUT",
    };
  },
  GetDeletePlan: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plan/delete/${planID}`,
      method: "DELETE",
    };
  },
  GetSinglePlanDetails: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plan/${planID}`,
      method: "GET",
    };
  },
  GetTogglePlanStatus: (planID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/plan/toggle-status/${planID}`,
      method: "PUT",
    };
  },
  GetCourses: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/courses/get?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetCreateCourse: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/create`,
      method: "POST",
    };
  },
  GetSingleCourseDetails: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/${courseID}`,
      method: "GET",
    };
  },
  GetStudentsEnrolledInCourse: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/students/${courseID}`,
      method: "GET",
    };
  },
  GetCourseBatches: (
    courseID: string,
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/batches/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetUpdateBatchTeacher: (batchID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/batch/teacher/${batchID}`,
      method: "PUT",
    };
  },
  GetRemoveBatchTeacher: (batchID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/batch/teacher/${batchID}`,
      method: "DELETE",
    };
  },
  GetUpdateCourse: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/update/${courseID}`,
      method: "PUT",
    };
  },
  GetDeleteCourse: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/delete/${courseID}`,
      method: "DELETE",
    };
  },
  GetToggleCourseStatus: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/toggle-status/${courseID}`,
      method: "PATCH",
    };
  },
  GetCreateLesson: (courseID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/lesson/create/${courseID}`,
      method: "POST",
    };
  },
  GetUpdateLesson: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/lesson/update/${lessonID}`,
      method: "PUT",
    };
  },

  GetLessonsUnderCourse: (
    courseID: string,
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/lesson/course/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetJoinLessonRoom: (
    lessonID: string,
    batchID: string,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/room/${lessonID}/${batchID}`,
      method: "GET",
    };
  },
  GetCreateRecording: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/recording/create`,
      method: "POST",
    };
  },
  GetRecordingsUnderCourse: (
    courseID: string,
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/recordings/${courseID}?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleLessonDetails: (lessonID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/lesson/${lessonID}`,
      method: "GET",
    };
  },

  GetTeachers: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/teachers?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetCreateTeacher: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/teacher/onboard`,
      method: "POST",
    };
  },
  GetAssignTeacherToCourse: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/course/assign-teacher`,
      method: "POST",
    };
  },
  GetBlogs: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/get?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetCreateBlog: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/create`,
      method: "POST",
    };
  },
  GetUpdateBlog: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/update/${blogID}`,
      method: "PUT",
    };
  },
  GetDeleteBlog: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/${blogID}`,
      method: "DELETE",
    };
  },
  GetSingleBlogDetails: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/${blogID}`,
      method: "GET",
    };
  },
  GetUpdateBlogContent: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/content/${blogID}`,
      method: "PATCH",
    };
  },
  GetDeleteBlogComment: (blogID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/blog/comment/${blogID}`,
      method: "DELETE",
    };
  },

  // STUDENTS ROUTES
  GetStudents: (page: number, limit: number): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/get?page=${page}&limit=${limit}`,
      method: "GET",
    };
  },
  GetSingleStudentDetails: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/${studentID}`,
      method: "GET",
    };
  },

  GetStudentsStats: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/stats`,
      method: "GET",
    };
  },
  GetSearchForStudents: (query: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/search?query=${query}`,
      method: "GET",
    };
  },
  GetFilterStudents: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/filter`,
      method: "POST",
    };
  },
  GetUpdateStudentProfile: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/${studentID}`,
      method: "PUT",
    };
  },
  GetDeleteStudentProfile: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/${studentID}`,
      method: "DELETE",
    };
  },
  GetToggleStudentSuspension: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/sus/${studentID}`,
      method: "PATCH",
    };
  },

  GetStudentTransactions: (
    page: number,
    limit: number,
  ): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/transactions?page=${page}&limit=${limit}`,
      method: "POST",
    };
  },
  GetStudentLifeHistory: (studentID: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/students/life-history/${studentID}`,
      method: "GET",
    };
  },
  GetUploadFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/s3/upload`,
      // route: `${baseURL}/file/upload`,
      method: "POST",
    };
  },
  GetUploadLargeFile: (): EndpointReponseProps => {
    return {
      route: `${baseURL}/file/s3/upload-large`,
      // route: `${baseURL}/file/upload-large`,
      method: "POST",
    };
  },
  GetVerifyTransaction: (reference: string): EndpointReponseProps => {
    return {
      route: `${baseURL}/admin/transaction/verify/${reference}`,
      method: "POST",
    };
  },
};
